(function () {

    angular
        .module('BBPublicBooking')
        .controller('DayList', dayListController);

    function dayListController($scope, $rootScope, DayService) {
        'ngInject';
        // Load up some day based data
        $rootScope.connection_started.then(() => {

                // Re-scoping the lost moment object inside the template
                $scope.moment = moment;

                if (!$scope.current_date && $scope.last_selected_date) {
                    $scope.selected_date = $scope.last_selected_date.clone();
                    setCurrentDate($scope.last_selected_date.clone().startOf('week'));
                } else if (!$scope.current_date) {
                    setCurrentDate(moment().startOf('week'));
                }
                return $scope.loadData();
            }
            , err => $scope.setLoadedAndShowError($scope, err, 'Sorry, something went wrong'));

        $scope.$on('BBTimeZoneOptions:timeZoneChanged', () => {
            if (!$scope.bb.current_item.date) return;
            $scope.selectDay($scope.bb.current_item.date);
        });

        $scope.selectDay = (day) => {
            if (!day.spaces || (day.spaces && (day.spaces === 0))) {
                return;
            }
            $scope.setLastSelectedDate(day.date);
            $scope.selected_date = day.date;
            $scope.bb.current_item.setDate(day);
            return $scope.$broadcast('dateChanged', day.date);
        };

        const setCurrentDate = function (date) {
            $scope.current_date = date;
            return $scope.current_date_js = $scope.current_date.toDate();
        };

        $scope.add = (type, amount) => {
            setCurrentDate($scope.current_date.add(amount, type));
            return $scope.loadData();
        };

        $scope.subtract = (type, amount) => {
            return $scope.add(type, -amount);
        };

        $scope.currentDateChanged = function () {
            const date = moment($scope.current_date_js).startOf('week');
            setCurrentDate(date);
            return $scope.loadData();
        };

        // disable any day but monday
        $scope.isDateDisabled = function (date, mode) {
            date = moment(date);
            const result = (mode === 'day') && ((date.day() !== 1) || date.isBefore(moment(), 'day'));
            return result;
        };

        // calculate if the current earlist date is in the past - in which case we might want to disable going backwards
        $scope.isPast = () => {
            if (!$scope.current_date) {
                return true;
            }
            return moment().isAfter($scope.current_date);
        };

        const checkForAndMarkSelectedDay = function (day) {
            if (day.date.isSame($scope.selected_date)) {
                $scope.selectDay(day);
            }
        };


        const handleDayData = function (days) {

            // group the day data by week
            $scope.weeks = _.chain(days)
                .each(day => checkForAndMarkSelectedDay(day))
                .groupBy(day => day.date.week())
                .sortBy(week => week[0].date.unix())
                .toArray()
                .value();

            $scope.$emit('bbDayList:loaded');

            return $scope.setLoaded($scope);

        };


        $scope.loadData = function () {

            $scope.notLoaded($scope);
            $scope.end_date = moment($scope.current_date).add(5, 'weeks');

            const params = {
                company: $scope.bb.company,
                cItem: $scope.bb.current_item,
                date: $scope.current_date.toISODate(),
                edate: $scope.end_date.toISODate(),
                client: $scope.client
            };

            DayService
                .query(params)
                .then(days => handleDayData(days))
                .catch(err => $scope.setLoadedAndShowError($scope, err, 'Sorry, something went wrong'));

        };


        $scope.setReady = function () {

            if ($scope.bb.current_item.date) {
                if ($scope.bb.current_item.reserve_ready) {
                    return $scope.addItemToBasket();
                } else {
                    return true;
                }
            } else {
                return false;
            }

        };

    }

})();



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/day-list/bb_day_list.controller.js